/** The jail: a stone floor ringed by iron bars. */
import { registerRenderPass } from './registry';

registerRenderPass({
  id: 'jail',
  layer: 'ground',
  order: 210,
  draw({ g, world: w, iso, ox, oy }) {
    g.lineWidth = 1;
    const J = w.map.jail;
    const R = 2.9;
    const corners = [
      [J.x - R, J.y - R],
      [J.x + R, J.y - R],
      [J.x + R, J.y + R],
      [J.x - R, J.y + R],
    ].map(([a, b]) => iso.proj(a!, b!));
    g.fillStyle = 'rgba(40,36,40,.55)';
    g.beginPath();
    corners.forEach(([cx, cy], k) => (k ? g.lineTo(cx + ox, cy + oy) : g.moveTo(cx + ox, cy + oy)));
    g.closePath();
    g.fill();
    for (let k = 0; k < 4; k++) {
      const [ax, ay] = corners[k]!;
      const [bx, by] = corners[(k + 1) % 4]!;
      for (let q = 0; q <= 12; q++) {
        const px = Math.round(ax + ((bx - ax) * q) / 12 + ox);
        const py = Math.round(ay + ((by - ay) * q) / 12 + oy);
        g.fillStyle = '#2a2a30';
        g.fillRect(px - 1, py - 22, 2, 22);
        g.fillStyle = '#6a6a76';
        g.fillRect(px - 1, py - 22, 1, 22);
      }
      g.strokeStyle = '#3a3a44';
      g.lineWidth = 2;
      for (const h of [0, 11, 22]) {
        g.beginPath();
        g.moveTo(ax + ox, ay + oy - h);
        g.lineTo(bx + ox, by + oy - h);
        g.stroke();
      }
      g.lineWidth = 1;
    }
  },
});
